import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAppQuery } from "shared/api/baseQuery";
import { AdditionalContractData } from "features/additionalContract/types/additionalContract";
import { StatusHistory } from "shared/types/statuses";
import { Dictionary } from "shared/types/dictionary";
import { Filter } from "shared/types/filters";
import { snackbarOnQueryStarted } from "middleware/snackbarOnQueryStarted";

const ENDPOINT = "additional-contract";
const additionalContractApi:any = createApi({
    reducerPath: "additionalContractApi",
    baseQuery: baseAppQuery,
    refetchOnMountOrArgChange: true,
    tagTypes: ["additionalContract"],
    endpoints: (builder)=>({
        getAdditionalContractById: builder.query<AdditionalContractData, string>({
            query: (id)=> `${ENDPOINT}/${id}`
        }),
        getAdditionalContractListById: builder.query<AdditionalContractData, {id:string, dataType:"application"|"contract"|"organization", filter: Filter}>({
            query: ({id, dataType, filter})=> {
                const queryParams = new URLSearchParams();
                queryParams.set("page", filter.pageNumber.toString());
                queryParams.set("size", filter.pageSize.toString());
                const idType = dataType==="organization"?"org": dataType;
                return `${ENDPOINT}/fetch-all-by-${dataType}?${idType}Id=${id}&${queryParams}`
            },
            providesTags: ["additionalContract"]
        }),
        getAdditionalContractListByOrganizationContract: builder.query<AdditionalContractData, {contractId:string, orgId:string}>({
            query: ({contractId, orgId})=> `${ENDPOINT}/fetch-all-by-organization-contract?contractId=${contractId}&orgId=${orgId}`
        }),
        getAdditionalContractHistoryById: builder.query<StatusHistory, string>({
            query: (id)=> `${ENDPOINT}/status-history/${id}`
        }),
        getAdditionalContractTypes: builder.query<Dictionary, Dictionary>({
            query: ()=>`dictionary/${ENDPOINT}-type/list`,
        }),
        getAdditionalContractDocumentById: builder.query<AdditionalContractData, string>({
            query:(id)=>`${ENDPOINT}/document/${id}`
        }),
        createAdditionalContract: builder.mutation<AdditionalContractData, AdditionalContractData>({
            query: (data)=>({
                url:ENDPOINT,
                method:"POST",
                body:data
            }),
            invalidatesTags: ["additionalContract"],
            onQueryStarted: snackbarOnQueryStarted({
                successMessage:"createAdditionalContractSuccess",
                errorMessage:"createAdditionalContractError",
              })
            
        }),
        updateAdditionalContract:builder.mutation<AdditionalContractData, AdditionalContractData>({
            query:(data)=>({
                url:ENDPOINT,
                method:"PUT",
                body:data,
            }),
            invalidatesTags: ["additionalContract"],
            onQueryStarted: snackbarOnQueryStarted({
                successMessage:"updateAdditionalContractSuccess",
                errorMessage:"updateAdditionalContractError",
              })
        }),
        rejectAdditionalContract:builder.mutation<AdditionalContractData, {additionalContractId:string,comment:string}>({
            query:(data)=>({
                url:`${ENDPOINT}/reject`,
                method:"POST",
                body: data
            }),
            invalidatesTags: ["additionalContract"],
        }),
        revisionAdditionalContract:builder.mutation<AdditionalContractData, {id:string,comment:string}>({
            query:({id:additionalContractId, comment})=>({
                url:`${ENDPOINT}/revision`,
                method:"POST",
                body: {additionalContractId, comment}
            }),
            invalidatesTags: ["additionalContract"],
            onQueryStarted: snackbarOnQueryStarted({
                successMessage:"revisionSuccess",
                errorMessage:"revisionError",
              })
        })


    })

});
export const{
    useGetAdditionalContractByIdQuery,
    useGetAdditionalContractListByIdQuery,
    useGetAdditionalContractByOrganizationContractQuery,
    useGetAdditionalContractHistoryByIdQuery,
    useGetAdditionalContractTypesQuery,
    useGetAdditionalContractDocumentByIdQuery,
    useCreateAdditionalContractMutation,
    useUpdateAdditionalContractMutation,
    useRejectAdditionalContractMutation,
    useRevisionAdditionalContractMutation,
} = additionalContractApi;
export default additionalContractApi;